import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CustomFormComponent } from '@services/formBuilder/abstract-custom-form-field';
import { MySchedulePage } from '@modules/profile/pages/my-schedule/my-schedule.page';

@Component({
  selector: 'app-user-work-schedules-button',
  template: `
    <ion-button
      *ngIf="userID > 0"
      class="page-button"
      color="secondary"
      fill="solid"
      (click)="openMySchedule()">
      <ion-icon name="calendar-outline" slot="start"></ion-icon>
      <span>{{ buttonText | translate }}</span>
    </ion-button>
  `,
  styles: [`
    @import "src/theme/core";
  `],
  standalone: false
})
export class UserWorkSchedulesButtonComponent extends CustomFormComponent {
  @Input() userID: number = 0;
  @Input() locationID: number = 0;
  @Input() buttonText: string = 'SHARED.User_Work_Schedules';

  constructor(private modalController: ModalController) {
    super();
  }

  public async openMySchedule(): Promise<void> {
    const modal = await this.modalController.create({
      component: MySchedulePage,
      cssClass: 'fullscreen-modal',
      componentProps: {
        isModal: true,
        userID: this.userID,
        locationID: this.locationID
      }
    });
    await modal.present();
  }
}
